import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { Col, Row } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import DateFild from '../DateTimePicker/DateFild';
import { postGst } from '../../apiservices/ApiServices';
import { FaLandmark } from "react-icons/fa";
import SelectFild from '../SelectFild/SelectFild';

const Gst = (props) => {
    const [isLoadings, setLoadings] = useState(false);

    const initialValues = {
        orgId: props.orgId || '',
        id: props.editGst?.gst_id || '',
        addressId: props.editGst?.org_address?.address_id || '',
        gstin: props.editGst?.gstin || '',
        effectiveFrom: props.editGst?.effective_from || '',
        effectiveTo: props.editGst?.effective_to || '',
        legalName: props.editGst?.legal_name || '',
        tradeName: props.editGst?.trade_name || '',
        filingFrequencyCode: props.editGst?.filing_frequency_code || '',
        registrationDate: props.editGst?.registration_date || '',

        isPrimary: props.editGst?.is_primary ? 1 : 0,
        sezFlag: props.editGst?.sez_flag ? 1 : 0,
        isdFlag: props.editGst?.isd_flag ? 1 : 0,
        einvoiceApplicable: props.editGst?.einvoice_applicable ? 1 : 0,
        ewaybillApplicable: props.editGst?.ewaybill_applicable ? 1 : 0,
    }



    const { values, errors, touched, handleBlur, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            const formData = new FormData();
            formData.append('org_id', values.orgId);
            formData.append('gst_id', values.id);
            formData.append('address_id', values.addressId);
            formData.append('gstin', values.gstin);
            formData.append('effective_from', values.effectiveFrom);
            formData.append('effective_to', values.effectiveTo);
            formData.append('legal_name', values.legalName);
            formData.append('trade_name', values.tradeName);
            formData.append('filing_frequency_code', values.filingFrequencyCode);
            formData.append('registration_date', values.registrationDate);

            formData.append('is_primary', values.isPrimary);
            formData.append('sez_flag', values.sezFlag);
            formData.append('isd_flag', values.isdFlag);
            formData.append('einvoice_applicable', values.einvoiceApplicable);
            formData.append('ewaybill_applicable', values.ewaybillApplicable);

            try {
                const res = await postGst(formData);
                props.toast.success(res.data.message);
                props.setAddGst(false)
                setLoadings(false);
                props.postUpdateOrganizationProfiles();

            } catch (error) {
                setLoadings(false);
                props.toast.error(error.response?.data?.message || "Error submitting data");
            }

        }
    })



    return (
        <>
            <div className='fieldsets'>
                <div className='fieldsets-title'>Add GST</div>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className='cols_5'>
                        <Row>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">GST In</label>
                                    <input
                                        type='text'
                                        id="gstin"
                                        name="gstin"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.gstin}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.gstin && touched.gstin && (
                                        <p className="errormsg">{errors.gstin}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Effective From</label>
                                    <DateFild
                                        value={values.effectiveFrom}
                                        onChange={(date) => setFieldValue('effectiveFrom', date)}
                                    />
                                    {errors.effectiveFrom && touched.effectiveFrom && (
                                        <p className="errormsg">{errors.effectiveFrom}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Effective To</label>
                                    <DateFild
                                        value={values.effectiveTo}
                                        onChange={(date) => setFieldValue('effectiveTo', date)}
                                    />
                                    {errors.effectiveTo && touched.effectiveTo && (
                                        <p className="errormsg">{errors.effectiveTo}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Legal Name</label>
                                    <input
                                        type='text'
                                        id="legalName"
                                        name="legalName"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.legalName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.legalName && touched.legalName && (
                                        <p className="errormsg">{errors.legalName}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Trade Name</label>
                                    <input
                                        type='text'
                                        id="tradeName"
                                        name="tradeName"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.tradeName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.tradeName && touched.tradeName && (
                                        <p className="errormsg">{errors.tradeName}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Filing Frequency Code</label>
                                    <SelectFild
                                        Firstop='Select Filing Frequency Code'
                                        selectName="filingFrequencyCode"
                                        options={[
                                            { name: 'Monthly', id: 'Monthly' },
                                            { name: 'Quarterly', id: 'Quarterly' },
                                        ]}
                                        value={values.filingFrequencyCode}
                                        onChange={(selectedOption) => setFieldValue("filingFrequencyCode", selectedOption?.value || "")}
                                        onBlur={handleBlur}
                                    />
                                    {errors.filingFrequencyCode && touched.filingFrequencyCode && (
                                        <p className="errormsg">{errors.filingFrequencyCode}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Registration Date</label>
                                    <DateFild
                                        value={values.registrationDate}
                                        onChange={(date) => setFieldValue('registrationDate', date)}
                                    />
                                    {errors.registrationDate && touched.registrationDate && (
                                        <p className="errormsg">{errors.registrationDate}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className='d-flex align-items-center'>
                                    <div className="form-group w-50">
                                        <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                            <label className="form-label">Is Primary</label>
                                            <div className="switchs" style={{ marginLeft: 10 }}>
                                                <input
                                                    type="checkbox"
                                                    id='isPrimary'
                                                    name='isPrimary'
                                                    className="form-control"
                                                    autoComplete='off'
                                                    checked={values.isPrimary === 1}
                                                    onChange={(e) => {
                                                        setFieldValue(
                                                            'isPrimary',
                                                            e.target.checked ? 1 : 0
                                                        );
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <span className="slider round"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group w-50">
                                        <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                            <label className="form-label">ISD Flag</label>
                                            <div className="switchs" style={{ marginLeft: 10 }}>
                                                <input
                                                    type="checkbox"
                                                    id='isdFlag'
                                                    name='isdFlag'
                                                    className="form-control"
                                                    autoComplete='off'
                                                    checked={values.isdFlag === 1}
                                                    onChange={(e) => {
                                                        setFieldValue(
                                                            'isdFlag',
                                                            e.target.checked ? 1 : 0
                                                        );
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <span className="slider round"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                        <label className="form-label">Invoice Applicable</label>
                                        <div className="switchs" style={{ marginLeft: 10 }}>
                                            <input
                                                type="checkbox"
                                                id='einvoiceApplicable'
                                                name='einvoiceApplicable'
                                                className="form-control"
                                                autoComplete='off'
                                                checked={values.einvoiceApplicable === 1}
                                                onChange={(e) => {
                                                    setFieldValue(
                                                        'einvoiceApplicable',
                                                        e.target.checked ? 1 : 0
                                                    );
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <span className="slider round"></span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                        <label className="form-label">Ewaybill Applicable</label>
                                        <div className="switchs" style={{ marginLeft: 10 }}>
                                            <input
                                                type="checkbox"
                                                id='ewaybillApplicable'
                                                name='ewaybillApplicable'
                                                className="form-control"
                                                autoComplete='off'
                                                checked={values.ewaybillApplicable === 1}
                                                onChange={(e) => {
                                                    setFieldValue(
                                                        'ewaybillApplicable',
                                                        e.target.checked ? 1 : 0
                                                    );
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <span className="slider round"></span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className='fieldsets'>
                        <div className='fieldsets-title'>Select Address</div>
                        <div className='banksbox'>
                            <div className='addressCardsbox'>
                                <Row>
                                    {props.addressList.map((item, index) => (
                                        <Col md={4} key={`gstAddress${item?.address_id}`}>
                                            <div className='addressCard'>
                                                <div className='addresshed'>
                                                    <input
                                                        type="radio"
                                                        name="address"
                                                        value={item?.address_id}
                                                        checked={item?.address_id == values.addressId}
                                                        onChange={() =>
                                                            setFieldValue('addressId', item?.address_id)
                                                        }
                                                    />
                                                </div>
                                                <div className='addrestype'>
                                                    <FaLandmark /><span>{item?.address_type}</span>
                                                </div>
                                                <p>{item?.address_line1} {item?.area}, {item?.city}, {item?.pincodes?.state_name},{item?.pincodes?.pincode}, {item?.pincodes?.country_name}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </div>
                    </div>

                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={() => props.setAddGst(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default Gst
